// ======================================================================
// File Name       : ContainerAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { openModal, hideModal } from './ModalAction';
import * as containerRequests from './httpRequests/container';
import * as courseRequests from './httpRequests/course';
import * as boxRequests from './httpRequests/box';
import * as itemRequests from './httpRequests/item';
import * as containerActionCreators from './actionCreators/container';
import * as courseActions from './CourseAction';
import * as userAction from './UserAction';
import * as boxActions from './BoxAction';
import * as itemActions from './ItemAction';
import * as ModalIds from '../constants/ModalIds';
import { STRUCTURE_TYPE, STRUCTURE_LEVEL, MODE } from '../constants';
import * as courseUtils from '../utils/CourseUtils';
import { isSuperUser } from '../utils/index';
import * as actionTypes from '../constants/actionTypes/container';

export function fetchCourseStructure() {
  return containerRequests.postContainerGetAllStructure();
}

export function exportCSV() {
  return dispatch => containerRequests.exportCSV();
}

/**
 * Initialize course list page
 */
export function init() {
  return async (dispatch, getState) => {
    const { authed } = getState();
    const { authedUser } = authed;
    const { userInfo } = authedUser;
    //const { userInfo } = getState();
    // Step11.1.0 START
    const { displayUserType, representationUserSecernId } = userInfo;
    let { userSecernId } = userInfo;
    const adminIsSuperUser = isSuperUser(displayUserType);
    let allCourseOwnerFlag = false;

    if (
      adminIsSuperUser &&
      authedUser.enterpriseManagementFunctionAuthorityInfo
        .superuserManagementAuthority > 0
    ) {
      const searchParam = {
        superuser_secern_id: userSecernId,
        return_max_record_num: 5000,
        start_position: 0,
      };
      const managementServiceListData = await
        userAction.postUserGetManagementServiceList(searchParam);
      allCourseOwnerFlag =
        managementServiceListData.serviceList?.find(
          (item) => item.institutionId === authedUser.institutionId
        )?.allCourseOwnerFlag ?? false;
      userSecernId = representationUserSecernId;
    }
    // Step11.1.0 END
    const requests = [];
    if (!allCourseOwnerFlag) {
      requests.push(dispatch(userAction.getUserCourseRelationList(userSecernId, true)));
      requests.push(dispatch(courseActions.getGroupCourseRelation({ userSecernId })));
    }

    Promise.all(requests).then(() => {
      let userCourseRelation = {
        bySecernId: {},
      };
      let groupCourseRelationList = [];
      // Step11.1.0 START
      if (!allCourseOwnerFlag) {
        if (getState().user.userCourseRelation) {
          userCourseRelation = getState().user.userCourseRelation;
        }

        if (
          getState().course.groupCourseRelationList &&
          getState().course.groupCourseRelationList.length
        ) {
          groupCourseRelationList = getState().course.groupCourseRelationList;
        }
      }
      // Step11.1.0 END

      dispatch(containerActionCreators.receiveInitTreeResult(false));
      fetchCourseStructure().then((data) => {
        dispatch(containerActionCreators.receiveCourseStructure(data.structureList, userCourseRelation.bySecernId, groupCourseRelationList));
        dispatch(containerActionCreators.receiveInitTreeResult(true));
        return {};
      });
    });
  };
}

export function openSortModal(structureSecernId) {
  return async (dispatch, getState) => {
    const { container: { structures: { bySecernId, courseSecernIds } } } = getState();
    const { parentCourseSecernId, parentBoxSecernId, structureType } = bySecernId[structureSecernId];

    let structureSecernIdList = [];
    if (structureType === STRUCTURE_TYPE.COURSE) {
      structureSecernIdList = [...courseSecernIds];
    } else {
      Object.keys(bySecernId).forEach((key) => {
        const cur = bySecernId[key];
        if (
          cur.structureType === structureType &&
          cur.parentCourseSecernId === parentCourseSecernId &&
          cur.parentBoxSecernId === parentBoxSecernId
        ) {
          structureSecernIdList.push(cur.structureSecernId);
        }
      });
    }

    structureSecernIdList.sort((a, b) => {
      if (!bySecernId[a] || !bySecernId[b]) {
        return 0;
      }
      if (bySecernId[a].displayOrder > bySecernId[b].displayOrder) {
        return 1;
      } else if (bySecernId[a].displayOrder < bySecernId[b].displayOrder) {
        return -1;
      }
      return 0;
    });

    dispatch(
      containerActionCreators.initDataForEditStructureDialog(structureSecernId, structureSecernIdList, structureType),
    );
    dispatch(openModal(ModalIds.COURSE_SORT));
  };
}

export function updateDisplayOrder(structureSecernIdList) {
  return containerActionCreators.updateDisplayOrder(structureSecernIdList);
}

export function saveDisplayOrder() {
  return async (dispatch, getState) => {
    const {
      container: {
        editingStructure: { structureType, structureSecernIdList, parentCourseSecernId, parentBoxSecernId },
      },
    } = getState();

    let key = '';
    switch (structureType) {
      case STRUCTURE_TYPE.COURSE:
        await courseRequests.postCourseEditDisplayOrder({
          courseList: buildDisplayOrderInfoList(structureSecernIdList, 'courseSecernId'),
        });
        break;
      case STRUCTURE_TYPE.BOX:
        await boxRequests.postBoxEditDisplayOrder({
          parentCourseSecernId,
          parentBoxSecernId,
          boxList: buildDisplayOrderInfoList(structureSecernIdList, 'boxSecernId'),
        });
        break;
      case STRUCTURE_TYPE.ITEM:
        await itemRequests.postItemEditDisplayOrder({
          parentBoxSecernId,
          itemList: buildDisplayOrderInfoList(structureSecernIdList, 'itemSecernId'),
        });
        break;
      default:
        key = '';
    }
    dispatch(sortStructures(structureSecernIdList));
    dispatch(hideModal());
  };
}

function sortStructures(structureSecernIdList) {
  return (dispatch, getState) => {
    const { container: { structures } } = getState();
    const structureTemp = { ...structures };
    if (structureTemp) {
      const { bySecernId } = structureTemp;
      if (bySecernId) {
        structureSecernIdList.reduce((acc, cur, index) => {
          if (bySecernId[cur]) {
            bySecernId[cur].displayOrder = index + 1;
          }
          return acc;
        }, []);
      }
    }
    return dispatch(containerActionCreators.reInitContainerTree(structureTemp));
  };
}

function buildDisplayOrderInfoList(structureSecernIdList, fieldName) {
  return structureSecernIdList.reduce((acc, cur, index) => {
    acc.push({
      [fieldName]: cur,
      displayOrder: index + 1,
    });

    return acc;
  }, []);
}

export function openDetailDialog(structureSecernId, nodeInfo) {
  let childSercernIdList = [];
  if (nodeInfo) {
    childSercernIdList = nodeInfo.children_d;
  }
  return openDialog(
    structureSecernId,
    courseActions.initDataForDetailEditConfirmDialog,
    boxActions.initDataForDetailEditConfirmDialog,
    itemActions.initDataForEditDetailConfirmContentLinkingDialog,
    false,
    childSercernIdList,
  );
}

export function openCourseRegisterDialog() {
  return dispatch => dispatch(courseActions.initDataForRegisterCourseDialog());
}

export function openRegisterDialog(structureSecernId) {
  return openDialog(
    structureSecernId,
    courseActions.initDataForRegisterCourseDialog,
    boxActions.initDataForRegisterBoxDialog,
    null,
    true,
    [],
  );
}

export function openContentLinkingRegisterDialog(parentBoxSecernId) {
  // sprint_20230522_tma START
  return dispatch => {
    const boxApiParam = {
      boxList: [parentBoxSecernId],
    };
    dispatch(boxActions.fetchBoxList(boxApiParam)).then(() => {
      dispatch(initDataForItemTreeDialog(parentBoxSecernId, STRUCTURE_TYPE.ITEM, true));
      dispatch(itemActions.initDataForContentLinkingRegisterDialog(parentBoxSecernId));
    });
  }
  // sprint_20230522_tma END
}

export function getStructureType(structureSecernId) {
  return (dispatch, getState) => {
    const { structures: { bySecernId } } = getState().container;
    const structure = bySecernId[structureSecernId];
    return structure.structureType;
  };
}

export function openDeleteDialog(structureSecernId) {
  return openDialog(structureSecernId, courseActions.deleteCourse, boxActions.deleteBox, itemActions.deleteItem);
}

function openDialog(
  structureSecernId,
  courseAction,
  boxAction,
  itemAction,
  isRegister,
  childSercernIdList) {
  return async (dispatch, getState) => {
    const { structures: { bySecernId } } = getState().container;
    const { structureType, contentType } = bySecernId[structureSecernId];
    let childItemSercernIdList = [];
    // get item list by childSercernIdList and check endConditionTypeForItem != 0
    const listItems = courseUtils.getExistItemsOfData(childSercernIdList, bySecernId);
    if (listItems && listItems.length) {
      const { itemList } = await itemRequests.postItemGetList({
        searchInfo: {
          itemList: listItems,
        },
        selectTargetData: 0,
      });

      childItemSercernIdList = itemList && itemList.length &&
      itemList.reduce((acc, cur) => {
        if (cur.endConditionTypeForItem !== 0) {
          acc.push(cur.itemSecernId);
        }
        return acc;
      }, []);
    }
    switch (structureType) {
      case STRUCTURE_TYPE.COURSE:
        if (isRegister) {
          return boxAction && dispatch(boxAction(structureSecernId, childItemSercernIdList));
        }
        return courseAction && dispatch(courseAction(structureSecernId, childItemSercernIdList));
      case STRUCTURE_TYPE.BOX:
        return boxAction && dispatch(boxAction(structureSecernId, childItemSercernIdList));

      case STRUCTURE_TYPE.ITEM:
        return itemAction && dispatch(itemAction(structureSecernId, contentType));

      default:
        break;
    }

    return null;
  };
}

export function deleteCourseStructure(courseSecernId) {
  return (dispatch, getState) => {
    const { structures } = getState().container;
    const structureTemp = { ...structures };
    if (structureTemp) {
      const { allSecernIds, bySecernId, courseSecernIds } = structureTemp;
      if (bySecernId && bySecernId[courseSecernId]) {
        delete bySecernId[courseSecernId];
      }
      if (courseSecernIds && courseSecernIds.indexOf(courseSecernId) > -1) {
        courseSecernIds.splice(courseSecernIds.indexOf(courseSecernId), 1);
      }
      if (allSecernIds && allSecernIds.indexOf(courseSecernId) > -1) {
        allSecernIds.splice(allSecernIds.indexOf(courseSecernId), 1);
      }
    }
    return dispatch(containerActionCreators.reInitContainerTree(structureTemp));
  };
}

export function deleteBoxStructure(boxSecernId) {
  return (dispatch, getState) => {
    const { structures } = getState().container;
    const structureTemp = { ...structures };
    if (structureTemp) {
      const { allSecernIds, bySecernId } = structureTemp;
      if (bySecernId && bySecernId[boxSecernId]) {
        delete bySecernId[boxSecernId];
      }
      if (allSecernIds && allSecernIds.indexOf(boxSecernId) > -1) {
        allSecernIds.splice(allSecernIds.indexOf(boxSecernId), 1);
      }
    }
    return dispatch(containerActionCreators.reInitContainerTree(structureTemp));
  };
}

export function deleteItemStructure(itemSecernId) {
  return (dispatch, getState) => {
    const { structures } = getState().container;
    const structureTemp = { ...structures };
    if (structureTemp) {
      const { allSecernIds, bySecernId } = structureTemp;
      if (bySecernId && bySecernId[itemSecernId]) {
        delete bySecernId[itemSecernId];
      }
      if (allSecernIds && allSecernIds.indexOf(itemSecernId) > -1) {
        allSecernIds.splice(allSecernIds.indexOf(itemSecernId), 1);
      }
    }
    return dispatch(containerActionCreators.reInitContainerTree(structureTemp));
  };
}

export function editCourseStructure(editType, courseSecernId) {
  return (dispatch, getState) => {
    const { structures } = getState().container;
    const { editingCourse } = getState().course;
    const structuresTemp = { ...structures };
    let maxDisplayOrder = 1;
    if (structuresTemp && editingCourse && courseSecernId) {
      const { bySecernId, allSecernIds, courseSecernIds } = structuresTemp;
      if (bySecernId) {
        if (editType === MODE.NEW_MODE) {
          Object.keys(bySecernId).reduce((acc, cur) => {
            if (bySecernId[cur] && bySecernId[cur].structureType === 0) {
              if (bySecernId[cur].displayOrder >= maxDisplayOrder) {
                maxDisplayOrder = bySecernId[cur].displayOrder;
              }
            }
            return acc;
          }, []);
          bySecernId[courseSecernId] = {
            contentType: null,
            dataAffiliationType: 0,
            displayOrder: (maxDisplayOrder + 1),
            hiddenFlag: null,
            parentBoxSecernId: null,
            parentCourseSecernId: null,
            publicPeriodFrom: '',
            publicPeriodTo: '',
            publicStatus: 1,
            structureName: '',
            structureSecernId: '',
            structureType: 0,
          };
        }
        const course = bySecernId[courseSecernId];
        course.publicPeriodFrom = editingCourse.publicPeriodFrom;
        course.publicPeriodTo = editingCourse.publicPeriodTo;
        course.structureName = editingCourse.courseName;
        course.structureSecernId = courseSecernId;
        course.publicStatus = editingCourse.publicStatus;
      }
      if (allSecernIds && allSecernIds.indexOf(courseSecernId) < 0) {
        allSecernIds.push(courseSecernId);
      }
      if (courseSecernIds && courseSecernIds.indexOf(courseSecernId) < 0) {
        courseSecernIds.push(courseSecernId);
      }
    }
    return dispatch(containerActionCreators.reInitContainerTree(structuresTemp));
  };
}

export function editBoxStructure(editType, boxSecernId, postBoxEditData) {
  return (dispatch, getState) => {
    const { structures } = getState().container;
    const { editingBox } = getState().box;
    let maxDisplayOrder = 1;
    let count = 0;
    const structuresTemp = { ...structures };
    if (structuresTemp && editingBox && boxSecernId) {
      const { bySecernId, allSecernIds, courseSecernIds } = structuresTemp;
      if (bySecernId) {
        if (editType === MODE.NEW_MODE) {
          Object.keys(bySecernId).reduce((acc, cur) => {
            if (
              bySecernId[cur] &&
              bySecernId[cur].structureType === 1
            ) {
              const test = (postBoxEditData.parentBoxSecernId && bySecernId[cur].parentBoxSecernId === postBoxEditData.parentBoxSecernId) ||
              (postBoxEditData.parentCourseSecernId && bySecernId[cur].parentCourseSecernId === postBoxEditData.parentCourseSecernId);
              if (test) {
                count += 1;
                if ((bySecernId[cur].displayOrder >= maxDisplayOrder)) {
                  maxDisplayOrder = bySecernId[cur].displayOrder;
                }
              }
            }
            return acc;
          }, []);
          bySecernId[boxSecernId] = {
            contentType: null,
            dataAffiliationType: 0,
            displayOrder: (maxDisplayOrder + 1),
            hiddenFlag: false,
            parentBoxSecernId: postBoxEditData.parentBoxSecernId,
            parentCourseSecernId: postBoxEditData.parentCourseSecernId,
            publicPeriodFrom: '',
            publicPeriodTo: '',
            publicStatus: 1,
            structureName: '',
            structureSecernId: '',
            structureType: 1,
          };
        }
        const box = bySecernId[boxSecernId];
        box.publicStatus = postBoxEditData.publicStatus;
        box.publicPeriodFrom = postBoxEditData.publicPeriodFrom;
        box.publicPeriodTo = postBoxEditData.publicPeriodTo;
        box.structureName = postBoxEditData.boxName;
        box.structureSecernId = boxSecernId;
      }
      if (allSecernIds && allSecernIds.indexOf(boxSecernId) < 0) {
        allSecernIds.push(boxSecernId);
      }
    }
    return dispatch(containerActionCreators.reInitContainerTree(structuresTemp));
  };
}

export function editItemStructure(parentBoxSecernId, itemSecernId) {
  return (dispatch, getState) => {
    const { editMode, edittingItem } = getState().item;
    const { structures } = getState().container;
    const structuresTemp = { ...structures };
    let maxDisplayOrder = 1;
    if (structuresTemp && edittingItem) {
      const { bySecernId, allSecernIds, courseSecernIds } = structuresTemp;
      if (bySecernId) {
        if (editMode === MODE.NEW_MODE) {
          Object.keys(bySecernId).reduce((acc, cur) => {
            if (
              bySecernId[cur] &&
              bySecernId[cur].structureType === 2 &&
              bySecernId[cur].parentBoxSecernId === edittingItem.parentBoxSecernId
            ) {
              if (bySecernId[cur].displayOrder >= maxDisplayOrder) {
                maxDisplayOrder = bySecernId[cur].displayOrder;
              }
            }
            return acc;
          }, []);
        }
        bySecernId[itemSecernId] = {
          contentType: edittingItem.contentInfo.contentType,
          dataAffiliationType: 0,
          displayOrder: editMode === MODE.EDIT_MODE ? edittingItem.displayOrder : (maxDisplayOrder + 1),
          hiddenFlag: false,
          parentBoxSecernId,
          parentCourseSecernId: null,
          publicPeriodFrom: edittingItem.publicPeriodFrom,
          publicPeriodTo: edittingItem.publicPeriodTo,
          publicStatus: edittingItem.publicStatus,
          structureName: edittingItem.itemName,
          structureSecernId: itemSecernId,
          structureType: 2,
        };
        if (bySecernId[parentBoxSecernId]) {
          bySecernId[parentBoxSecernId].hasSubStructures = true;
        }
      }
    }
    return dispatch(containerActionCreators.reInitContainerTree(structuresTemp));
  };
}

export function destroy() {
  return dispatch => dispatch(containerActionCreators.destroyCourseTree());
}

// sprint_20230522_tma START
export function getDataItemTree(data){
  return dispatch => dispatch(containerActionCreators.receiveCourseStructureItemTree(data));
}

export function selectedItemOnDialog(selectedItemOnDialog) {
  return containerActionCreators.doSelectedItemOnDialog(selectedItemOnDialog);
}

export function removeItemListRelation(index) {
  return containerActionCreators.removeItemListRelation(index);
}

export function removeDataUserHasGroupAndRole() {
  return {
    type: actionTypes.REMOVED_DATA_WITH_SELECTED_ITEM_LIST,
  };
}

export function initDataForItemTreeDialog(structureSecernId, structureType, isRegister) {
  return containerActionCreators.initDataForItemTreeDialog(structureSecernId, structureType, isRegister);
}

// sprint_20230522_tma END
